function Madeby() {
  return (
    <div className="footer">
      <p>
        Created with ♥ by Gilang Abdian, 2025. Based on Cdepolitan Case Study.
      </p>
    </div>
  );
}

export default Madeby;
